import React from "react";
import { CartItem as CartItemType } from "../types";
import { CartItemComponent } from "./CartItem";

type Props = {
  items: CartItemType[];
  onQuantityChange: (productId: string, delta: number) => void;
  onRemove: (productId: string) => void;
  onCheckout: () => void;
  isLoading?: boolean;
};

const container: React.CSSProperties = {
  padding: 8,
  color: "#fff",
};
const header: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: 8,
  borderBottom: "1px solid #2a2a2a",
};
const totalRow: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  paddingTop: 8,
  fontWeight: 700,
};
const checkoutBtn: React.CSSProperties = {
  marginTop: 8,
  width: "100%",
  padding: "12px 16px",
  background: "#ff6b35",
  color: "#000",
  border: 0,
  borderRadius: 6,
  fontWeight: 700,
  cursor: "pointer",
};

export const Cart: React.FC<Props> = ({
  items,
  onQuantityChange,
  onRemove,
  onCheckout,
  isLoading,
}) => {
  const total = items.reduce((acc, i) => acc + i.product.price * i.quantity, 0);
  return (
    <div style={container}>
      <div style={header}>
        <strong>Cart</strong>
        <span>{items.length} items</span>
      </div>
      <div>
        {items.length === 0 && (
          <div style={{ padding: 8, color: "#bbb" }}>Cart is empty</div>
        )}
        {items.map((item) => (
          <CartItemComponent
            key={item.product.id}
            item={item}
            onQuantityChange={onQuantityChange}
            onRemove={onRemove}
          />
        ))}
      </div>
      <div style={totalRow}>
        <span>Total</span>
        <span>${total.toFixed(2)}</span>
      </div>
      <button
        style={checkoutBtn}
        onClick={onCheckout}
        disabled={items.length === 0 || isLoading}
      >
        {isLoading ? "Processing..." : "Checkout with Stripe"}
      </button>
    </div>
  );
};

export default Cart;
